<template> 
   <div class="row w-100">

      <div v-if="!isMobile" class="fitcontents"  >
         <div class=" text-center text-sm-center px-0 telephone " @click="check"  v-bind:class="[callstate.state, isMobile ? 'mobile' : 'non_mobile' ]" v-if=" callstate.state 
         != 'ring_in' "  >
            <img :src="callstate.image"   class="img-fluid d-block mx-auto phone_icon ">
         </div>
         <!-- <button  v-if="callstate.state == 'active_call'" @click="mute_toggle" >
            mute/unmute: {{mute}}
         </button>    -->
      </div>

      <div  style="width: 25%;" v-else-if=" callstate.state !== 'ring_in' "  >
<!--          Handles cellphones -->
         <div class="  px-0 telephone  fitcontents" v-on:dblclick="check"  @click="double_tap_message"  v-bind:class="callstate.state" v-if=" callstate.state == 'hangup' "  >
            <p class="tap_message" v-if="double_tap_message_outgoing" >Double tap to end call</p>
            <span><img :src="callstate.image"   class="img-fluid d-block mx-auto phone_icon "></span>
         </div>

         <div class="  px-0 telephone test  " @click="check"  v-bind:class="[callstate.state, isMobile ? 'mobile' : 'non_mobile' ]" v-if=" callstate.state == 'call' ">
            <span><img :src="callstate.image"   class="img-fluid d-block mx-auto phone_icon "></span>
         </div>

         <div class="  px-0 telephone fitcontents"  v-on:dblclick="check"  @click="double_tap_message" v-bind:class="callstate.state" v-if=" callstate.state == 'active_call' "  >
            <p class="tap_message" v-if="double_tap_message_outgoing" >Double tap to end call</p>
            <span><img :src="callstate.image"   class="img-fluid d-block mx-auto phone_icon "></span>
         </div>
      </div>
         
      <div class=" incoming_accept call" @click="accept_call"  v-bind:class="callstate.state"  v-if=" callstate.state == 'ring_in' " >
         <span><img src="../assets/images/call.png"   class="img-fluid d-block mx-auto phone_icon incoming_accept_shake "></span>
         <div  ></div>
      </div>
      
         <div class=" incoming_decline hangup " @click="decline_call"  v-bind:class="callstate.state"  v-if="callstate.state == 'ring_in' ">
         <span><img src="../assets/images/hangup.png"   class="img-fluid d-block mx-auto phone_icon "></span>
            {{emit_incoming()}}
      </div>
      
      <div class=" text-center text-sm-center contact_details"  v-bind:class="[callstate.state  == 'active_call' && ((is_muted_by.state == 'false' || typeof is_muted_by.state == 'undefined') && !mute ) ? 'active':  '', mute_colours()]">
         <span  class="name lead">{{peer.name}}</span>
         <!-- <p>Q{{id}}</p> -->
         <!-- {{((is_muted_by.state == 'false' || typeof is_muted_by.state == 'undefined') && !mute ) }} -->
      </div>
      <div class="text-center text-sm-center message"  v-bind:class="[!peer.active? 'disable_mute' : 'disable_mute' ]"   @click="mute_toggle"  v-if="isMobile" >
      </div>
      <div class="text-center text-sm-center message"  v-bind:class="[!peer.active? 'disable_mute' : 'active_mute' ]"   @click="mute_toggle"  v-if="!isMobile" >
            <img src="../assets/images/mute_mic_speaker.png"   class="img-fluid d-block mx-auto phone_icon " v-if="mute == false"   >
            <img src="../assets/images/unmute_mic_speaker.png"   class="img-fluid d-block mx-auto phone_icon " v-if="mute == true" >
         </div>
         <!-- <button v-on:click="Check1">
            Test
         </button>  -->
   </div>
</template> 

<script>

   import mute_mic_speaker from "../assets/images/mute_mic_speaker.png";

   export default {
      name: 'Contact',
      props: {
         peer: Object,
         studiocaller: Object,
         id: String,
         username: String,
         callstate: Object,
         isMobile: Boolean,
         is_muted_by: Object,
      },
      data () {
         return {
            mute : false,
            double_tap_message_outgoing: false,
            name : this.studiocaller.wss.peers[this.id].name,
            sender_detail : this.studiocaller.wss.invitee_detail[0]
            // muted: false, 
         }
      },
      mounted: function () {
         // alert('HOME!!!!!');
         console.log(typeof is_muted_by );
         if (typeof is_muted_by == 'undefined' ) {
            this.muted = false;
         }
         this.studiocaller.wss.peers[this.id].missed_call=false;

         if(this.name== this.sender_detail.sender && this.sender_detail.call_on_login) {
            this.studiocaller.wss.action('call', this.id);
            this.is_muted_by.state = "false";
            this.studiocaller.wss.invitee_detail[0].call_on_login = 0 ;
         }

      },
      methods : {
         Check1: function () {
            // this.studiocaller.wss.peers[this.id].missed_call=true;
            console.log(this.studiocaller.wss.invitee_detail[0]);
         }, 
         check: function () {
            if(this.peer.deleted) {
                delete this.studiocaller.wss.peers[this.id] ;
            } else {
               if(this.peer.callingus) {
               } else if(this.peer.calledbyus) {
                  this.studiocaller.wss.action('hangup', this.id);
                  this.$emit('call:hangup',"true");
               } else if(this.peer.active) {
                  this.studiocaller.wss.action('hangup', this.id);
                  this.studiocaller.wss.action('app', this.id , {cmd:'mute', data:{state:"false",mute_by: this.studiocaller.name}});
               } else if(!this.peer.active && !this.peer.calledbyus && !this.peer.callingus) {
                  this.studiocaller.wss.action('call', this.id);
                  this.is_muted_by.state = "false";
               }
            }
         },
         accept_call: function () {
            this.studiocaller.wss.action('accept', this.id);
            console.log('Accepted call');
//             this.$emit('call:accepted',"true");
         },
         decline_call: function () {
            this.studiocaller.wss.action('decline', this.id);
         },
         emit_incoming : function () {
            this.$emit('call:incoming',"true");
         },
         mute_toggle : function () {
            console.log('This peer');
            console.log( this.studiocaller.wss.peers[this.id].rtp ) ;
            if(this.mute) {
               // alert('Set Gain :1 ');
               // alert("true1: "+this.id);
               console.log('Mute user ['+this.id+']');
               this.studiocaller.wss.action('app', this.id , {cmd:'mute', data:{state:"false",mute_by: this.studiocaller.name}});
               this.studiocaller.wss.peers[this.id].rtp.setgain_i(1.0);
               this.studiocaller.wss.peers[this.id].rtp.setgain_o(1.0);
               this.mute = false ;
            } else {
               // alert('Set Gain:1 ');
               // alert("true2: "+this.id);
               console.log('Unmute user ['+this.id+']');
               this.studiocaller.wss.action('app', this.id , {cmd:'mute', data:{state:"true",mute_by: this.studiocaller.name}  });
               this.studiocaller.wss.peers[this.id].rtp.setgain_i(0.0);
               this.studiocaller.wss.peers[this.id].rtp.setgain_o(0.0);
               this.mute = true ;
            }
         },
         mute_print : function () {
            return this.mute
         },
         mute_colours : function () {

               if(this.is_muted_by.state == 'true' && this.mute) {
                  return 'muted_both'
               } else if(this.is_muted_by.state == 'true') {
                  return 'muted_by'
               } else if(this.mute) {
                   return 'muted_by_us'  
               } else {
                  return '';
               }
         },
         double_tap_message : function () {
            this.double_tap_message_outgoing=true;
            var _this = this;
            setTimeout(function() { 
               _this.double_tap_message_outgoing = false; 
            }, 1000 );            
         },
      },
      // computed: {
      //    muted_by: function () {
      //       alert('Yes');
      //       if (this.is_muted_by.state && this.is_muted_by.id == this.id) {
      //          alert('true');
      //          return true
      //       }
      //       return  false 
      //    }
      // }
   }
</script>

<style scoped>
   .incoming_accept {
      -webkit-animation: accpet_glow 1500ms infinite;
      -moz-animation: accpet_glow 1500ms infinite;
      -o-animation: accpet_glow 1500ms infinite;
      animation: accpet_glow 1500ms infinite;
/*       width:50%; */
   }
   .incoming_accept_shake {
       animation: incoming_accept_shake 0.5s infinite ;
   }
   .incoming_decline{
      -webkit-animation: incoming_decline 1500ms infinite;
      -moz-animation: incoming_decline 1500ms infinite;
      -o-animation: incoming_decline 1500ms infinite;
      animation: incoming_decline 1500ms infinite;
   }
   .active_mute{
    margin: auto ; 
   }
   .disable {
      background: lightgrey;  
    }
   .muted_by {
      background: #aa0a0a36;
   }
   .muted_by_us {
      background: #ff840038;
   }
   .muted_both {
      background: #ff840038;
   }
   .disable_mute {
    pointer-events: none;
    opacity: 0.5;
    background: #CCC;
    padding: 1px 0px 1px 0px;
    margin: 0;
    width: 25%;
   }
   .incoming_accept,
   .incoming_decline,
   .hangup,
   .active_call
   {
      width: 25%;
   }
   .call:hover {
      background-color:#28a74545;
   }
   
   .call .mobile {
      width: 38%;
   }
   .call .non_mobile {
      width: 38%;
   }
   .ring_in{
      width:12.5%;
   }
   .contact_details {
      width: 50%; 
   }
   
   .hangup:hover {
      background-color:#fad7d7;
   }
   .active_call:hover {
      background-color:#fad7d7;
   }
   
   .active {
       background-color:#f0fff4;
   }
   .phone_icon {
      width: 38px ;
   }
   .contact_details {
      padding: 0px;
/*       width: 40px; */
      border-left: rgb(228, 230, 231);
      border-right: rgb(228, 230, 231);
      border-style: solid;
      border-width: 0px 2px 0px 2px;
   }

   .message {
      /* margin: auto; */
      width: 25%
   }
   
   .message_icon{
      width: 25px;
   }
   
   .message:hover {
      background-color: #ffbc002e; 
   }
   
   .row {
      padding: 0px;
      margin:0px;
   }
   
   img {
      padding: 3px;
   }
   .fitcontents {
      display:contents;
   }
   .telephone {
      margin: auto ;
   }
   /* .call_icon{
      height: 40%;
   } */
   @media (max-width: 767px) {
      .col-sm-6 {
/*       -ms-flex: 0 0 50%; */
      }
      .telephone {
/*          border-top:  1px solid #dfdfdf; */
         margin: auto ;
      }
      .contact_details {
         border-bottom: 1px solid #dfdfdf;
      }
/*      .message {
         margin-bottom: 30px; 
         border-bottom: 2px solid #dedbdb; 
         border-bottom: 1px solid blue; 
      }*/
      .incoming_accept
      .incoming_decline
      {
         width: 11%;
      }
      .incoming_decline
      {
         width: 12%;
      }
      .tap_message{
         margin:0px;
         padding:0px;
      }

   }
   
   @-webkit-keyframes accpet_glow {
      0% { background-color: #85db5947; -webkit-box-shadow: 0 0 3px #85db5947;   }
      50% { background-color: #85db5970; -webkit-box-shadow: 0 0 40px #85db5970; }
      100% { background-color: #85db598f; -webkit-box-shadow: 0 0 3px #85db598f; }
   }

   @-moz-keyframes accpet_glow {
      0% { background-color: #85db5947; -webkit-box-shadow: 0 0 3px #85db5947;   }
      50% { background-color: #85db5970; -webkit-box-shadow: 0 0 40px #85db5970; }
      100% { background-color: #85db598f; -webkit-box-shadow: 0 0 3px #85db598f; }
   }

   @-o-keyframes accpet_glow {
      0% { background-color: #85db5947; -webkit-box-shadow: 0 0 3px #85db5947;   }
      50% { background-color: #85db5970; -webkit-box-shadow: 0 0 40px #85db5970; }
      100% { background-color: #85db598f; -webkit-box-shadow: 0 0 3px #85db598f; }
   }

   @keyframes accpet_glow{
      0% { background-color: #85db5947; -webkit-box-shadow: 0 0 3px #85db5947;   }
      50% { background-color: #85db5970; -webkit-box-shadow: 0 0 40px #85db5970; }
      100% { background-color: #85db598f; -webkit-box-shadow: 0 0 3px #85db598f; }
   }
   
   @-webkit-keyframes incoming_decline {
      0% { background-color: #fad7d799; -webkit-box-shadow: 0 0 3px #fad7d799;   }
      50% { background-color: #fad7d7d6; -webkit-box-shadow: 0 0 40px #fad7d7d6; }
      100% { background-color: #fad7d7; -webkit-box-shadow: 0 0 3px #fad7d7;     }
   }

   @-moz-keyframes incoming_decline {
      0% { background-color: #fad7d799; -webkit-box-shadow: 0 0 3px #fad7d799;   }
      50% { background-color: #fad7d7d6; -webkit-box-shadow: 0 0 40px #fad7d7d6; }
      100% { background-color: #fad7d7; -webkit-box-shadow: 0 0 3px #fad7d7;     }
   }

   @-o-keyframes incoming_decline {
      0% { background-color: #fad7d799; -webkit-box-shadow: 0 0 3px #fad7d799;   }
      50% { background-color: #fad7d7d6; -webkit-box-shadow: 0 0 40px #fad7d7d6; }
      100% { background-color: #fad7d7; -webkit-box-shadow: 0 0 3px #fad7d7;     }
   }

   @keyframes incoming_decline{
      0% { background-color: #fad7d799; -webkit-box-shadow: 0 0 3px #fad7d799;   }
      50% { background-color: #fad7d7d6; -webkit-box-shadow: 0 0 40px #fad7d7d6; }
      100% { background-color: #fad7d7; -webkit-box-shadow: 0 0 3px #fad7d7;     }
   }
   
   @-moz-keyframes incoming_accept_shake { 100% { -moz-transform: rotate(10deg); } }
   @-webkit-keyframes incoming_accept_shake { 100% { -webkit-transform: rotate(10deg); } }
   @keyframes incoming_accept_shake { 100% { -webkit-transform: rotate(10deg); } }
   
   
</style>
